import React, { useState } from 'react'
import { ChecklistServicesApi } from '../../service/api/ChecklistServicesApi';

import { useHistory } from "react-router-dom";

const hierarchyArray = ["question", "ambito", "requisito", "principio", "fatQual"]; // in this order so that for example fatQual > requisito

const EditChecklistLogic = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingButtons, setIsLoadingButtons] = useState(false);
  const [opScopes, setOpScopes] = useState([]);
  const [qualitativeEvaluationOnly, setQualitativeEvaluationOnly] = useState(true);
  const [checklistId, setChecklistId] = useState();
  const [originalData, setOriginalData] = useState(); // will be used on save/evaluate
  const [finalData, setFinalData] = useState([]);
  
  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();

  const initialConfiguration = (queryStringChecklistId, fattoriQualificanti) => {
     const initialOpScopes = [];
    console.log("fattoriQualificanti: ", fattoriQualificanti)

    // creating the initialOpScopes array
    let opScopesArrayCreated = false;
    for (let fatQual of fattoriQualificanti) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        for (let requisito of principio.checklistCosoRequisiti) {
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions && ambito.checklistQualitativeQuestions.length > 0) { // only needed if I receive ambiti with no questions
              for (let question of ambito.checklistQualitativeQuestions) {
                for (let opScope of question.checklistQualitativeQuestionOperationalScopes) {
                  const tempOS = {
                    id: opScope.operationalScope.id,
                    name: opScope.operationalScope.name,
                    tooltip: opScope.operationalScope.tooltip,
                    infoIconIsVisible: false
                  }
                  initialOpScopes.push(tempOS);
                  console.log("qualitative opScope", initialOpScopes)
                }
                opScopesArrayCreated = true;
                break;
              }
            }
            console.log("Pre IF")
            if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              for (let driver of ambito.checklistQuantitativeDrivers) {
                for (let question of driver.checklistQuantitativeQuestions) {
                  if (question.checklistQuantitativeQuestionOperationalScopes && question.checklistQuantitativeQuestionOperationalScopes.length > 0) {
                    for (let opScope of question.checklistQuantitativeQuestionOperationalScopes) {
                      const tempOS = {
                        id: opScope.operationalScope.id,
                        name: opScope.operationalScope.name,
                        active: opScope.operationalScope.active,
                        infoIconIsVisible: false
                      };
                      initialOpScopes.push(tempOS);
                      console.log("quantitativeee opScope", initialOpScopes)
                    }
                    opScopesArrayCreated = true;
                    break;
                  }
                }
              }
            }
            if (opScopesArrayCreated) break;
          }
          if (opScopesArrayCreated) break;
        }
        if (opScopesArrayCreated) break;
      }
      if (opScopesArrayCreated) break;
    }
    initialOpScopes.sort((a, b) => a.id > b.id ? 1 : -1);
    console.log("sorted opScopes: ", initialOpScopes);

    setOpScopes(initialOpScopes);

    // HERE THE SORTING OF THE ARRAYS IS TAKING PLACE
    fattoriQualificanti.sort((a, b) => a.position > b.position ? 1 : -1);
    for (let fatQual of fattoriQualificanti) {
      fatQual.checklistCosoPrincipi.sort((a, b) => a.position > b.position ? 1 : -1);
      for (let principio of fatQual.checklistCosoPrincipi) {
        principio.checklistCosoRequisiti.sort((a, b) => a.position > b.position ? 1 : -1);
        for (let requisito of principio.checklistCosoRequisiti) {
          requisito.checklistCosoAmbiti.sort((a, b) => a.position > b.position ? 1 : -1);
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              ambito.checklistQualitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
            } 
            if (ambito.checklistQuantitativeDrivers.length > 0) {
              ambito.checklistQuantitativeDrivers.sort((a, b) => a.id > b.id ? 1 : -1);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                checklistQuantitativeDriver.checklistQuantitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
              }
            }
          }
        }
      }
    }
    // console.log("sortedData: ", fattoriQualificanti);

    let mainData = [];
    for (let fatQual of fattoriQualificanti) {
      // const osFatQual = Array(initialOpScopes.length).fill(false); 
      mainData.push(createDataObject(fatQual, "fatQual", initialOpScopes)); // id, position(?probably not needed) title, type, operationalScopes values
      for (let principio of fatQual.checklistCosoPrincipi) {
        mainData.push(createDataObject(principio, "principio", initialOpScopes));
        for (let requisito of principio.checklistCosoRequisiti) {
          mainData.push(createDataObject(requisito, "requisito", initialOpScopes));
          for (let ambito of requisito.checklistCosoAmbiti) {
            let ambitoIsQualitative = true;
            if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              ambitoIsQualitative = false;
              mainData.push(createDataObject(ambito, "ambito", initialOpScopes, "quantitative"));
              setQualitativeEvaluationOnly(false);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                for (let question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                  // console.log(question.question.substring(0,10));
                  // for (let opScope of question.checklistQuantitativeQuestionOperationalScopes) {
                  //   console.log(opScope.operationalScope.name, opScope.enabled);
                  // }
                  mainData.push(
                    createQuestionObject(
                      question,
                      question.checklistQuantitativeQuestionOperationalScopes,
                      fatQual.id,
                      principio.id,
                      requisito.id,
                      ambito.id,
                      initialOpScopes,
                      "quantitative"
                  )); 
                }
              }
            }
            if (ambito.checklistQualitativeQuestions.length > 0 && ambitoIsQualitative) {
              mainData.push(createDataObject(ambito, "ambito", initialOpScopes, "qualitative"));
              for (let question of ambito.checklistQualitativeQuestions) {
                // console.log(question.question.substring(0,10));
                // for (let opScope of question.checklistQualitativeQuestionOperationalScopes) {
                //   console.log(opScope.operationalScope.name, opScope.enabled);
                // }
                mainData.push(
                  createQuestionObject(
                    question,
                    question.checklistQualitativeQuestionOperationalScopes,
                    fatQual.id,
                    principio.id,
                    requisito.id,
                    ambito.id,
                    initialOpScopes,
                    "qualitative" // questionType
                )); 
              }
            }
          }
        }
      }
    }

    // fatQual "span" property will determine the number of rows that this title will expand
    let count = 0;
    for (let i = mainData.length - 1; i >= 0; i--) {
      const arrayEl = mainData[i];
        // length of each fattore qualificante
        if(arrayEl.type && arrayEl.type === "fatQual") {
          arrayEl.span = count;
          // Object.defineProperty(arrayEl, "span", { value: count });
          count = 0;
        } else {
          count++;
        }
      if (!arrayEl.type) {
        for (const [opScope, opScopeValue] of Object.entries(arrayEl.operationalScopes)) {
          if (opScopeValue === true) {
            let hierarchyThreshold = 0;
            for (let j = i - 1; j >= 0; j--) {
              const el = mainData[j];
                if (el.type) {
                  let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
                  if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) { // it is the highest hierarchy element, thus we stop the iteration
                    el.operationalScopes[opScope] = true;
                    break;
                  }
                  else if (currentElementHierarchyLevel > hierarchyThreshold) {
                    el.operationalScopes[opScope] = true;
                    hierarchyThreshold++;
                  } else continue;
                }
            }
          }
        }
      }
    }

    setFinalData([...mainData]);
    setIsLoading(false);
  }

  const createDataObject = ({ id, title, tooltip, position }, givenType, operationalScopes, ambitoType) => {
    const operScopes = {};
    for (let i = 0; i < operationalScopes.length; i++) {
      operScopes[operationalScopes[i].name] = false;
      // Object.defineProperty(opScopes, opScopeKeys[i], { value: false });
    }
    const dataObject = {
      id,
      title,
      ...(tooltip !== undefined && {tooltip}),
      type: givenType,
      operationalScopes: operScopes,
      isHidden: false,
      isCollapsed: false,
    }
    
    if (givenType === "ambito") {
      dataObject.ambitoType = ambitoType;
    }
    if (givenType === "principio") {
      dataObject.position = position;
    }

    return dataObject;
  }

  const createQuestionObject = (
    { 
      position, 
      question: title, 
      id: questionId, 
      tooltip, 
      displayId 
    }, 
    opScopesObjects, 
    fatQualId, 
    principioId, 
    requisitoId, 
    ambitoId, 
    operationalScopes, 
    questionType
  ) => {
    // transform the opScopes information
    const tempOpScopes = {};

    // creating the operationalScopes property for each record with the CORRECT ORDER
    for (let opScope of operationalScopes) { // the order will be determined by this array which was created based on the first question's opScopes
      for (let opScopesObject of opScopesObjects) {
        if (opScopesObject.operationalScope.name === opScope.name) {
          let opScopeName = opScopesObject.operationalScope.name;
          let opScopeValue = opScopesObject.enabled;
          tempOpScopes[opScopeName] = opScopeValue;
          break;
        }
      }
    }

    // for (let opScopesObject of opScopesObjects) {
    //   let opScope = opScopesObject.operationalScope.name;
    //   let opScopeValue = opScopesObject.enabled;
    //   tempOpScopes[opScope] = opScopeValue;
    // }

    return {
      operationalScopes: tempOpScopes,
      position,
      title,
      tooltip,
      displayId,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      questionId,
      questionType, // qualitative, quantitative
      isHidden: false
    }
  }

  const updateOriginalData = (record, data, operationType, opScope, newQuestion, newTitle) => {
    let procedureCompleted = false;
    for (let fatQual of data) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        if (record.principioId === principio.id)
        for (let requisito of principio.checklistCosoRequisiti) {
          if (record.requisitoId === requisito.id)
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (record.ambitoId === ambito.id) {
              if (record.questionType === "qualitative") {
                console.log("before adding length: ", ambito.checklistQualitativeQuestions.length)
                let questionIndex = 0;
                if (record.position === 0) {
                  updatingDataOperations( 0, undefined, operationType, ambito.checklistQualitativeQuestions, opScope, newQuestion, newTitle);
                } else {
                  for (const [qIndex, question] of ambito.checklistQualitativeQuestions.entries()) {
                    if (question.position === record.position) {
                      questionIndex = qIndex;
                      console.log("updateOriginalData record: ", record)
                      console.log("updateOriginalData matched question: ", question)
                      updatingDataOperations(record.position, question, operationType, ambito.checklistQualitativeQuestions, opScope, newQuestion, newTitle);
                      if (operationType === "tickingBox" || operationType === "untickingBox" || operationType === "updatingQuestion") {
                        procedureCompleted = true;
                      }
                      break;
                    }
                  }
                }
                if (!procedureCompleted) {
                  let startingElIndex = 0;
                  if (record.position === 0) {
                    startingElIndex = 1;
                  } else {
                    startingElIndex = questionIndex + 2;
                  }
                  if (operationType === "addingQuestion" && startingElIndex < ambito.checklistQualitativeQuestions.length) {
                    console.log("after adding length: ", ambito.checklistQualitativeQuestions.length)
                    for (let i = startingElIndex; i < ambito.checklistQualitativeQuestions.length; i++) {
                      ambito.checklistQualitativeQuestions[i].position++;
                    }
                  }
                  else if (operationType === "removingQuestion") {
                    for (let i = questionIndex; i < ambito.checklistQualitativeQuestions.length; i++) {
                      console.log("removingQuestion ambito: ", ambito)
                      ambito.checklistQualitativeQuestions[i].position--;
                    }
                  }
                }
              } else {
                for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                  for (const question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                    if (question.position === record.position) {
                      updatingDataOperations(record.position, question, operationType, checklistQuantitativeDriver.checklistQuantitativeQuestions, opScope, newQuestion, newTitle);
                    }
                  }
                }
              }
            }
            if (procedureCompleted) break;
          }
          if (procedureCompleted) break;
        }
        if (procedureCompleted) break;
      }
      if (procedureCompleted) break;
    }
  }

  const higherHierarchyElementsHandler = (record, data, operationType, opScope) => {
    console.log("record type: ", record.type, record.id)
    let elementFound = false;
    let operationComplete = false;
    for (let fatQual of data) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        if (record.id === principio.id && record.type === "principio") {
          elementFound = true;
        }
          for (let requisito of principio.checklistCosoRequisiti) {
            if (record.id === requisito.id && record.type === "requisito") {
              elementFound = true;
            }
              for (let ambito of requisito.checklistCosoAmbiti) {
                if (record.id === ambito.id && record.type === "ambito") {
                  elementFound = true;
                }
                if (elementFound) {
                  if (ambito.checklistQualitativeQuestions.length > 0) {
                    for (const question of ambito.checklistQualitativeQuestions) {
                      updatingDataOperations(record.position, question, operationType, ambito.checklistQualitativeQuestions, opScope);
                    }
                  } 
                  if (ambito.checklistQuantitativeDrivers.length > 0) {
                    for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                      for (const question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                        updatingDataOperations(record.position, question, operationType, checklistQuantitativeDriver.checklistQuantitativeQuestions, opScope);
                      }
                    }
                  }
                }
                console.log("elementFound && record.type === ambito ", elementFound && record.type === "ambito");
                if (elementFound && record.type === "ambito") {
                  operationComplete = true;
                  break;
                }
              }
            if ((elementFound && record.type === "requisito") || operationComplete) {
              operationComplete = true;
              break;
            }
          }
        if ((elementFound && record.type === "principio") || operationComplete) break;
      }
      if (elementFound) break;
    }
  }

  const updatingDataOperations = (position, question, operationType, questionsArray, opScope, newQuestion, newTitle) => {
    let questionIndex;
      switch(operationType) {
        case "tickingBox": 
          if (question && question.hasOwnProperty("checklistQualitativeQuestionOperationalScopes")) {
            for (const scope of question.checklistQualitativeQuestionOperationalScopes) {
              if (scope.operationalScope.name === opScope) {
                scope.enabled = true;
                break;
              }
            }
          } else {
            for (const scope of question.checklistQuantitativeQuestionOperationalScopes) {
              if (scope.operationalScope.name === opScope) {
                scope.enabled = true;
                break;
              }
            }
          }
          break;
        case "untickingBox":
          if (question && question.hasOwnProperty("checklistQualitativeQuestionOperationalScopes")) {
            for (const scope of question.checklistQualitativeQuestionOperationalScopes) {
              if (scope.operationalScope.name === opScope) {
                scope.enabled = false;
                break;
              }
            }
          } else {
            for (const scope of question.checklistQuantitativeQuestionOperationalScopes) {
              if (scope.operationalScope.name === opScope) {
                scope.enabled = false;
                break;
              }
            }
          }
          break;
        case "addingQuestion":
          if (position !== 0) {
            questionIndex = questionsArray.findIndex(el => el.position === position)
            questionsArray.splice(questionIndex + 1, 0, createQuestionInOriginalForm(newQuestion));
          } else {
            questionsArray.splice(0, 0, createQuestionInOriginalForm(newQuestion));
          }
          break;
        case "updatingQuestion":
          question.question = newTitle;
          break;
        case "removingQuestion":
          questionIndex = questionsArray.findIndex(el => el.position === position)
          questionsArray.splice(questionIndex, 1); // position starts from one, that is why I pass position - 1
          // update the position property for the rest of the questions, probably immediately after the SWITCH method
          break;
        default:
      }
  }

  const createQuestionInOriginalForm = (newQuestion) => {
    const questionToAdd = {};
    // .map() : start
      const tempOpScopes = Object.keys(newQuestion.operationalScopes).map(key => {
        let opScopeId;
        for (let i = 0; i < opScopes.length; i++) {
          if (opScopes[i].name === key) {
            opScopeId = opScopes[i].id;
            break;
          }
        }
        // if (newQuestion.questionType === "qualitative") {
          return {
            operationalScope: {
              id: opScopeId,
              name: key,
              active: true
            },
            enabled: false,
            checklistQualitativeAnswerType: null,
            // checklistQualitativeAnswerType: {
            //   id: 1,
            //   answer: "Good"
            // }
          }
        // } else {
        //   return {
        //     operationalScope: {
        //       id: opScopeId,
        //       name: key,
        //       active: true
        //     },
        //     enabled: false,
        //     answer: 1
        //   }
        // }      
      });
      // .map() : end

      // if (newQuestion.questionType === "qualitative") {Scope
        questionToAdd.id = null;
        questionToAdd.checklistQualitativeQuestionOperationalScopes = [...tempOpScopes];
        questionToAdd.position = newQuestion.position;
        questionToAdd.question = newQuestion.title;
        questionToAdd.tooltip = null;
        questionToAdd.displayId = newQuestion.displayId;
        // questionToAdd.reference = null;
        questionToAdd.supervisedEntity = true;
        questionToAdd.notSupervisedEntity = true;
        questionToAdd.note = null;
      // } else {
      //   questionToAdd.id = null;
      //   questionToAdd.checklistQuantitativeQuestionOperationalScopes = [...opScopes];
      //   questionToAdd.position = newQuestion.position;
      //   questionToAdd.question = newQuestion.title;
      // }
      return questionToAdd;
  }

  const tickingElementHandler = (index, type, opScope) => {
    let newData = [...finalData];
    newData[index].operationalScopes[opScope] = true;
    const record = newData[index];

    if (record.type !== "principio") {
      let hierarchyThreshold = 0; // question hierarchy level (lowest higherarchy)
      if (record.type) {
        hierarchyThreshold = hierarchyArray.findIndex(item => item === type); //defining the hierarchy level of the selected element
      }
      
      for (let i = index - 1; i >= 0; i--) {
        const el = finalData[i];
        if (el.type) {
            let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
            if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) { // it is the highest hierarchy element, thus we stop the iteration
              el.operationalScopes[opScope] = true;
              break;
            }
            else if (currentElementHierarchyLevel > hierarchyThreshold) {
              hierarchyThreshold++;
              el.operationalScopes[opScope] = true;
            }
          }
      }
    }

    if (record.type) {
      const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === type); //defining the hierarchy level of the selected element
      for (let i = index + 1; i < newData.length; i++) {
        const el = newData[i];
        if (el.type) {
          if (hierarchyArray.findIndex(item => item === el.type) < hierarchyLevelOfSelectedElement) {
            el.operationalScopes[opScope] = true;
          } else break;
        } else {    
            // it is a question object, thus we immediately set the op. scope to true
            el.operationalScopes[opScope] = true;
        }
      }
    }

    // Explanation: all the quant. questions belonging to an ambito must be selected/deselected all together
    if (record.questionType === "quantitative") {
      for (let i = index - 1; i >= 0; i--) {
        if (newData[i].type) {
          break;
        } else {
          newData[i].operationalScopes[opScope] = true;
        }
      }
      for (let i = index + 1; i < newData.length; i--) {
        if (newData[i].type) {
          break;
        } else {
          newData[i].operationalScopes[opScope] = true;
        }
      }
    }

    const tempDataObject = [...originalData];
    if (record.questionType) {
      if (record.questionType === "qualitative") {
        updateOriginalData(record, tempDataObject, "tickingBox", opScope) // clicked item is a question
      } else {
        for (let i = index; i >= 0; i--) {
          if (newData[i].type === "ambito") {
            higherHierarchyElementsHandler(newData[i], tempDataObject, "tickingBox", opScope); // using the logic in higherHierarchyElementsHandler that triggers when the element that is clicked is an ambito higherHierarchyElementsHandler
            break;
          }
        }
      }
    } else {
      higherHierarchyElementsHandler(record, tempDataObject, "tickingBox", opScope); // clicked item is an ambito/requisito/principio
    }

    setOriginalData(tempDataObject);
    setFinalData(newData);
  }

  const untickingElementHandler = (index, type, opScope) => {
    let newData = [...finalData];
    const record = newData[index];
    record.operationalScopes[opScope] = false  ;

    if (record.type) {
    // if (record.type === "principio") {
      const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === type); //defining the hierarchy level of the selected element
      for (let i = index + 1; i < newData.length; i++) {
        const el = newData[i];
        if (el.type) {
          if (hierarchyArray.findIndex(item => item === el.type) < hierarchyLevelOfSelectedElement) {
            el.operationalScopes[opScope] = false;
          } else break;
        } else {    
            // it is a question object, thus we immediately set the op. scope to false
            el.operationalScopes[opScope] = false;
        }
      }
    } 

    // Explanation for the following logic: We search for the end of the current principio (or the end of data). 
    // Once found, we use its index as an ending point for our operations and then we iterate backwards until we reach the previous principio in the table
    let endingPoint = 0;
      for (let i = index; i < newData.length; i++) {
        const el = newData[i];
        if (i === newData.length - 1) { // if this is the last element of the checklist
          endingPoint = newData.length;
          break;
        }
        if (el.type === "principio") {
          endingPoint = i;
          break;
        }
        if (el.type) {
          el.operationalScopes[opScope] = false;
        }
      }
    // We set all elements' scope that are not questions to false
      if (record.type !== "principio") {
        for (let i = index - 1; i >= 0; i--) {
          if (newData[i].type) {
            newData[i].operationalScopes[opScope] = false;
          }
          if (newData[i].type === "principio") {
            break;
          }
        }
      }
    // In the following iteration, we set the non-question elements' opScope based on the checked questions, 
    // that is why we set these element's scope to false in the previous step 
    // All this logic is based on the logic of the initial useEffect hook, where all elements' scopes are determined by the questions checked throughout the structure
    for (let i = endingPoint - 1; i >= 0; i--) {
      const arrayEl = newData[i];
      if (!arrayEl.type) {
        // the iteration of opScopes below is unnecessary, we only need to check for the selected opScope.
        // It was probably copied from the inital useEffect, which checks all opScopes for each element
        for (const [opScope, opScopeValue] of Object.entries(arrayEl.operationalScopes)) {
          if (opScopeValue === true) {
            let hierarchyThreshold = 0;
            for (let j = i - 1; j >= 0; j--) {
              const el = newData[j];
                if (el.type) {
                  let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
                  if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) { // it is the highest hierarchy element, thus we stop the iteration
                    el.operationalScopes[opScope] = true;
                    break;
                  }
                  else if (currentElementHierarchyLevel > hierarchyThreshold) {
                    el.operationalScopes[opScope] = true;
                    hierarchyThreshold++;
                  }
                }
            }
          }
        }
      } else if (arrayEl.type === "principio") {
        break;
      }
    }

    // Explanation: all the quant. questions belonging to an ambito must be selected/deselected all together
    if (record.questionType === "quantitative") {
      for (let i = index - 1; i >= 0; i--) {
        if (newData[i].type) {
          newData[i].operationalScopes[opScope] = false; // the ambito that holds the questions is set to false and then we break
          break;
        } else {
          newData[i].operationalScopes[opScope] = false;
        }
      }
      for (let i = index + 1; i < newData.length; i--) {
        if (newData[i].type) {
          break;
        } else {
          newData[i].operationalScopes[opScope] = false;
        }
      }
    }

    const tempDataObject = [...originalData];
    if (record.questionType) {
      if (record.questionType === "qualitative") {
        updateOriginalData(record, tempDataObject, "untickingBox", opScope) // clicked item is a question
      } else {
        for (let i = index; i >= 0; i--) {
          if (newData[i].type === "ambito") {
            higherHierarchyElementsHandler(newData[i], tempDataObject, "untickingBox", opScope);
            break;
          }
        }
      }

    } else {
      higherHierarchyElementsHandler(record, tempDataObject, "untickingBox", opScope); // clicked item is an ambito/requisito/principio
    }

    setOriginalData(tempDataObject);
    setFinalData(newData);
  };


  const addQuestionHandler = (index) => {
    let newData = [...finalData];

    const operScopes = {};
    for (let i = 0; i < opScopes.length; i++) {
      operScopes[opScopes[i].name] = false;
    }

    let fatQualId;
    let principioId;
    let requisitoId;
    let ambitoId;

    let isInsideInitialPrincipio = true;

    let newDisplayId = 0;

    let hierarchyThreshold = 0;
    if (newData[index].type === "ambito") {
      ambitoId = newData[index].id;
      hierarchyThreshold = 1;
    } else {
      hierarchyThreshold = 0; // hierarchyArray.findIndex(item => item === "question");
      if (!newData[index].type) {
        newDisplayId = newData[index].displayId + 1;
      }
    }
    for (let i = index - 1; i >= 0; i--) {
      const el = newData[i];
      if (el.type) {
        let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
        if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "fatQual")) { // it is the highest hierarchy element, thus we stop the iteration
          fatQualId = el.id;
          el.span += 1; // increase the "span" property value of the fatQual element since a question was added
          break;
        }
        else if (currentElementHierarchyLevel > hierarchyThreshold) { // I will not be receiving empty "ambito" elements so I don't need to check for that
          hierarchyThreshold++;
          if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) {
            principioId = el.id;
            isInsideInitialPrincipio = false;
          }
          else if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "requisito")) {
            requisitoId = el.id; 
          }
          else {
            ambitoId = el.id; 
          }
        } else continue;
      } else {
        if (isInsideInitialPrincipio) {
          if (newDisplayId <= el.displayId) {
            newDisplayId = el.displayId + 1;
          }
        } 
      }
    }
    
    for (let i = index + 1; i < newData.length; i++) {
      const el = newData[i];
      if (el.type) {
        if (el.type === "principio") {
          break;
        } else {
          continue;
        }
      } else {
        if (newDisplayId <= el.displayId) {
          newDisplayId = el.displayId + 1;
        };
      }
    }

    const newQuestion = {
        title: "",
        position: newData[index].position ? newData[index].position + 1 : 1, // if the clicked element is an ambito (it has no pos prop (it has in the original form but not in the flattened array) then the next question will have pos 1)
        fatQualId,
        principioId,
        requisitoId,
        ambitoId,
        tooltip: null,
        displayId: newDisplayId,
        operationalScopes: operScopes,
        questionType: "qualitative", // since the user can only add qualitative questions
        // id: null,
        // supervisedEntity: true,
        // notSupervisedEntity: true,
        // newQuestion: true
    }

    newData.splice(index + 1, 0, newQuestion);
    
    // the code below can be used to update the position of the questions in the same ambito
    for (let i = index + 2; i < newData.length; i++) { // index = element that was clicked, index + 1 = the added question, so we want to make changes from index + 2 and on
      const el = newData[i];
      if (!el.type) { // question elements don't have a type property
        el.position += 1;
      } else {
        break;
      }
    }
    
    const record = newData[index].type ? {...newQuestion} : newData[index];
    if (newData[index].type) { // if the clicked element was an ambito which has a type prop
      record.position = 0; // position = 0 will be interpreted by updateOriginalData() that the clicked element was an ambito
    }
    // console.log(newQuestion);
    const tempDataObject = [...originalData];
    updateOriginalData(record, tempDataObject, "addingQuestion", undefined, newQuestion); // updateOriginalData(record, data, operationType, opScope, newQuestion, newTitle)

    console.log("addQuestionHandler");
    setOriginalData(tempDataObject);
    setFinalData(newData);
  }

  const removeQuestionHandler = (index) => {
    let newData = [...finalData];
    let questionToBeRemoved = newData[index];
    console.log("questionToBeRemoved: ", questionToBeRemoved)
    newData.splice(index, 1);

    // reducing fattoreQualificante length by 1
    for (let i = index - 1; i >= 0; i--) {
      const el = newData[i];
      if (el.type && el.type === "fatQual") {
        el.span -= 1;
        break;
      }
    }
    for (let i = index; i < newData.length; i++) {
      const el = newData[i];
      if (!el.type) {
        el.position -= 1;
      } else {
        break;
      }
    }

    const tempDataObject = [...originalData];
    updateOriginalData(questionToBeRemoved, tempDataObject, "removingQuestion"); // updateOriginalData(record, data, operationType, opScope, newQuestion, newTitle)
    setOriginalData(tempDataObject);
    setFinalData(newData);
  }

  const updateQuestionHandler = (index, title) => {
    let newData = [...finalData];
    newData[index].title = title;
    // newData[index].questionType = questionType;

    const record = newData[index];
    const tempDataObject = [...originalData];
    updateOriginalData(record, tempDataObject, "updatingQuestion", undefined, undefined, title); // updateOriginalData(record, data, operationType, opScope, newQuestion, newTitle)
    setOriginalData(tempDataObject);
    setFinalData(newData);
  }

  const isQuestionEmpty = () => {
    for (const el of finalData) {
      if (el.questionType && (!el.title || (el.title && el.title.replace(/\s/g, "").length === 0))) {
        console.log("question with no title")
        modalDataHandler("", "All question fields must contain text", 'error', modalCloseHandler);
        return true;
      }
    }
    return false;
  }

  const collapseElement = function(index, isCollapsedUpdatedValue) {
    // clicked elements will never be questions
    let newData = [...finalData];
    newData[index].isCollapsed = isCollapsedUpdatedValue;
    const record = newData[index];
    let newIsHiddenValue = false;
    if (isCollapsedUpdatedValue === true) {
      newIsHiddenValue = true;
    }
    
    console.log("isHidden new value: ", isCollapsedUpdatedValue)
    // let invalidInputFound = false;
    // DESCRIPTION of all the variables used below: (hierarchy is the order of the "layers", from question to fatQual)
    // 1. hierarchyLevelOfSelectedElement: The hierarchy of the element that was clicked
    // 2. currentCollapsedElementHierarchy: The hierachy of the current element that was detected to be collapsed while iterating through the newData array
    // 3. elHierarchy: the hierarchy of the current iteration element
    // 4. isInsideCollapsedElement: a boolean that checks if we are inside a collapsed element

    let currentCollapsedElementHierarchy = 0;
    let isInsideCollapsedElement = false;
    const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === record.type); //defining the hierarchy level of the selected element
    console.log("hierarchyLevelOfSelectedElement: ", hierarchyLevelOfSelectedElement);
    for (let i = index + 1; i < newData.length; i++) {
      let el = newData[i];
      if (el.type) {
        let elHierarchy = hierarchyArray.findIndex(type => type === el.type);
        if (elHierarchy < hierarchyLevelOfSelectedElement) {
          if (el.isCollapsed && !isInsideCollapsedElement) {
            isInsideCollapsedElement = true;
            currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
            el.isHidden = newIsHiddenValue;
            // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
            //   if (!el.hasValidChildren) {
            //     invalidInputFound = true;
            //   }
            // }
            continue;
          }
          if (isInsideCollapsedElement) {
              if (elHierarchy >= currentCollapsedElementHierarchy) {
                if (el.isCollapsed) {
                  currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
                  // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
                  //   if (!el.hasValidChildren) {
                  //     invalidInputFound = true;
                  //   }
                  // }
                } else {
                  isInsideCollapsedElement = false;
                }
                el.isHidden = newIsHiddenValue;
              }
          } else {
              el.isHidden = newIsHiddenValue; 
          }
        } else break;
      } else {
        // element is a question
        if (!isInsideCollapsedElement) {
          el.isHidden = newIsHiddenValue;
          // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
          //   for (const value of Object.values(el.invalidInputs)) {
          //     if (value === true) {
          //       invalidInputFound = true;
          //       break;
          //     }
          //   }
          // }
        }
      }
    }
    // newData[index].hasValidChildren = invalidInputFound ? false : true;

    setFinalData(newData);
  }

  const areOpScopesUnchecked = () => { // all operational scopes are unchecked for at least one question
    for (const el of finalData) {
      if (el.questionType) {
        let atLeastOneOpScopeIsChecked = false;
        for (const opScope of Object.values(el.operationalScopes)) {
          if(opScope === true) {
            atLeastOneOpScopeIsChecked = true;
            break;
          }
        }
        if (!atLeastOneOpScopeIsChecked) {
          modalDataHandler("", "At least one operational scope must be checked for every question before validating", 'error', modalCloseHandler);
          return true;
        }
      }
    }
    return false;
  }

  
  const saveChecklistHandler = () => {
    if (!isQuestionEmpty()) {
      setIsLoadingButtons(true);
      console.log("finalData: ", finalData);
      console.log("originalData ", originalData);
      const checklistServicesApi = new ChecklistServicesApi();
      console.log("checklistID: ", checklistId);
      checklistServicesApi.updateChecklistHierarchy(originalData, checklistId, (error, data) => { // (id, callback)
        if (!error) {
          setIsLoadingButtons(false); // this setter is not outside the if statement because if it was, when the component unmounts, we get a memory leak warning because we would 
          // be trying to update an unmounted component
          modalDataHandler("", `The checklist with id ${checklistId} is saved!`, 'notification', () => history.push("/checklist-monitor"))  
        } else {
          setIsLoadingButtons(false);
          modalDataHandler(``, "Error! The checklist was not saved!", 'error', () => setModalShow(false));
        }
      });
    }
  }

  const evaluateChecklistHandler = () => {
    if (!isQuestionEmpty() && !areOpScopesUnchecked()) {
      setIsLoadingButtons(true);
      console.log("finalData: ", finalData);
      console.log("originalData ", originalData);
      const checklistServicesApi = new ChecklistServicesApi();
      checklistServicesApi.updateChecklistHierarchy(originalData, checklistId, (saveError, updateHierarchyResponse) => { // (id, callback)
        if (!saveError) { 
          // modalDataHandler("", `The checklist with id ${checklistId} is saved!`, 'notification', () => setModalShow(false));
          checklistServicesApi.toEvaluate(checklistId, (evalError, data) => { 
            if (!evalError && data) {
              console.log("validateChecklistResponse: ", data);
              setIsLoadingButtons(false);
              modalDataHandler("", data.message, 'notification', () => history.push("/checklist-monitor"));
            } else {
              setIsLoadingButtons(false);
              modalDataHandler(``, "Error! The checklist was saved but could not be validated!", 'error', () => setModalShow(false));
            }
            });
        } else {
          setIsLoadingButtons(false);
          modalDataHandler(``, "Error! The checklist was not saved!", 'error', () => setModalShow(false));
        }
        
      });
    } else console.log("failed")
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
    setModalAction(action ? () => action : null);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  return {
    /* state */ error, setError,
    isLoading, setIsLoading,
    isLoadingButtons, setIsLoadingButtons,
    finalData, 
    checklistId, setChecklistId,
    opScopes, setOpScopes,
    qualitativeEvaluationOnly, 
    originalData, setOriginalData,
    modalShow,
    modalAction,
    modalTitle,
    modalMessage,
    modalType,
    /* functions */ 
    initialConfiguration,
    createDataObject,
    createQuestionObject,
    updateOriginalData,
    createQuestionInOriginalForm,
    tickingElementHandler,
    untickingElementHandler,
    addQuestionHandler,
    removeQuestionHandler,
    updateQuestionHandler,
    saveChecklistHandler,
    evaluateChecklistHandler,
    modalDataHandler,
    modalCloseHandler,
    collapseElement
  }
}

export default EditChecklistLogic;
